import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/app/home/Home'
import External from '@/app/external/External'
import ExternalPurged from '@/app/external/ExternalPurged'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '*', redirect: '/' },
    { path: '/', name: 'Home', component: Home },
    { path: '/external/:uuid', name: 'External', component: External },
    { path: '/external-purged/:idQualisoft', name: 'ExternalFile', component: ExternalPurged }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js